import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../../images/logo/infiniy-logo.png';
import partner1 from '../../images/partners/logo-1.png';
import partner2 from '../../images/partners/logo-2.png';
import './Footer.css';

const InstagramIcon = () => (
  <svg className="common-footer-social-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg className="common-footer-social-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const defaultLinks = {
  learn: [
    // { label: 'Courses', path: '/courses' },
    { label: 'Tracks', path: '/tracks/corporates' },
    // { label: 'Resources', path: '/resources' },
    { label: 'Blog', path: '/blog' },
  ],
  company: [
    { label: 'About', path: '/about' },
    { label: 'Contact', path: '/contact' },
  ],
  legal: [
    { label: 'Privacy Policy', path: '/privacy-policy' },
    { label: 'Terms of Use', path: '/terms-of-service' },
  ],
};

const Footer = ({ logoText, tagline, links, socialLinks, copyright }) => {
  const linkGroups = links || defaultLinks;
  const defaultSocial = [
    // { label: 'Twitter', href: 'https://twitter.com', icon: '𝕏' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/infinyskills/about/?viewAsMember=true', icon: 'in' },
    // { label: 'YouTube', href: 'https://www.instagram.com/infinyskills/', icon: '▶' },
     { label: 'Instagram', href: 'https://www.instagram.com/infinyskills/', icon: 'insta' },
  ];
  const social = socialLinks || defaultSocial;

  const renderLink = (item) =>
    item.path != null ? (
      <Link to={item.path}>{item.label}</Link>
    ) : (
      <a href={item.href || '#'}>{item.label}</a>
    );

  return (
    <footer className="common-footer">
      <div className="common-footer-container">
        <div className="common-footer-main">
          <div className="common-footer-brand">
            <Link to="/" className="common-footer-logo-link" aria-label="infinySkills home">
              <img src={logoImg} alt="" className="common-footer-logo-img" loading="lazy" />
              {logoText && <span className="common-footer-logo-text">{logoText}</span>}
            </Link>
            <div className="common-footer-partners" aria-label="Partner logos">
              <div className="common-footer-partners-img">
                <img src={partner1} alt="Salesforce partner" loading="lazy" />
              </div>
              <div className="common-footer-partners-img">
                <img src={partner2} alt="KonfHub partner" loading="lazy" />
              </div>
            </div>
            <p className="common-footer-tagline">{tagline || 'Learn without limits.'}</p>
            <div className="common-footer-social">
              {social.map((item, i) => (
                <a
                  key={i}
                  href={item.href}
                  className="common-footer-social-link"
                  aria-label={item.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.icon === 'insta' && <InstagramIcon />}
                  {item.icon === 'in' && <LinkedInIcon />}
                  {item.icon !== 'insta' && item.icon !== 'in' && (item.icon || item.label)}
                </a>
              ))}
            </div>
          </div>
          <nav className="common-footer-nav" aria-label="Footer navigation">
            <div className="common-footer-col">
              <h4>Learn</h4>
              <ul>
                {(linkGroups.learn || linkGroups.courses || []).map((link, i) => (
                  <li key={i}>{renderLink(link)}</li>
                ))}
              </ul>
            </div>
            <div className="common-footer-col">
              <h4>Company</h4>
              <ul>
                {(linkGroups.company || []).map((link, i) => (
                  <li key={i}>{renderLink(link)}</li>
                ))}
              </ul>
            </div>
            <div className="common-footer-col">
              <h4>Legal</h4>
              <ul>
                {(linkGroups.legal || []).map((link, i) => (
                  <li key={i}>{renderLink(link)}</li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
        <div className="common-footer-bottom">
          <p className="common-footer-copyright">
            {copyright || `© ${new Date().getFullYear()} infinySkills. All rights reserved.`}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
